import type { TabLink } from '@panel/PanelHeader/panelHeader.types';

import { CustomCodePage } from '../shared/tabs';
import { TableImporterSettingsTab } from './tabs/settings.tab.tableImporter';
import { UiTableImporter } from './tabs/ui.tab.tableImporter';

export namespace TableImporterConfig {
  export enum SubPath {
    Ui = 'ui',
    Code = 'code',
    Settings = 'settings'
  }

  export const TAB_LINKS: TabLink[] = [
    {
      content: 'Table',
      path: SubPath.Ui
    },
    {
      content: 'Code',
      path: SubPath.Code
    },
    {
      content: 'Settings',
      path: SubPath.Settings
    }
  ] as const;

  export const SUBPATHS_TO_FC_MAP = {
    [SubPath.Ui]: <UiTableImporter />,
    [SubPath.Code]: <CustomCodePage />,
    [SubPath.Settings]: <TableImporterSettingsTab />
  } as const satisfies Record<SubPath, React.ReactNode>;
}
